import { userReducer } from '@/store/user';
import { investorReducer } from '@/store/investor';
import { api, authApi } from '@/api';
import { entitiesActions } from '@/store/entities';

export const auth = (data, callback, t) => async (dispatch) => {
  dispatch(entitiesActions.showLoader(t ? t('Loading') : 'Loading'));

  await authApi
    .auth(data)
    .then((res) => {
      if (res.data.accountStatus === 'NOT_ACTIVE') {
        throw new Error('INVESTOR_HAS_BEEN_BLOCKED');
      }

      if (res.status === 200) {
        const { data } = res;
        dispatch(investorReducer.setInvestor(data));
        dispatch(userReducer.setEmail(data.email));
        dispatch(userReducer.setId(data.id));

        callback();
      }
    })
    .catch((e) => {
      const errorMessage = e?.response?.data?.message;
      if (errorMessage === 'WRONG_PASSWORD') {
        dispatch(entitiesActions.addToastInfo(t ? t('Wrong password') : 'Wrong password'));
      }
      if (e.message === 'INVESTOR_HAS_BEEN_BLOCKED') {
        dispatch(
          entitiesActions.addToastInfo(
            t ? t('This user has been blocked') : 'This user has been blocked'
          )
        );
      }
    })
    .finally(() => {
      dispatch(entitiesActions.hideLoader());
    });
};

export const setTokenByEmail = (data, t) => async (dispatch) => {
  dispatch(entitiesActions.showLoader(t ? t('Loading') : 'Loading'));

  await authApi
    .getToken(data)
    .then((res) => {
      if (res.status === 200) {
        const { data } = res;
        dispatch(setToken(data));
      }
    })
    .catch((e) => {
      const errorMessage = e.response.data.message;
      if (errorMessage === 'CONFIRM_CODE_IS_WRONG') {
        dispatch(entitiesActions.addToastInfo(t ? t('Wrong code') : 'Wrong code'));
      }
      if (errorMessage === 'CONFIRM_CODE_EXPIRED') {
        dispatch(entitiesActions.addToastInfo(t ? t('Code is expired') : 'Code is expired'));
      }
    })
    .finally(() => {
      dispatch(entitiesActions.hideLoader());
    });
};

export const setToken = (data) => (dispatch) => {
  const { accessToken, userRole } = data;

  localStorage.setItem('token', accessToken);
  localStorage.setItem('userRole', userRole);
  api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
  dispatch(setRole(userRole));
};

export const setReferralToken = (accessToken) => (dispatch) => {
  dispatch(userReducer.setReferralToken(accessToken));
};

export const setRole = (userRole) => (dispatch) => {
  dispatch(userReducer.setRole(userRole));
};

export const setEmail = (email) => (dispatch) => {
  dispatch(userReducer.setEmail(email));
};

export const hideAppContainer = () => (dispatch) => {
  dispatch(userReducer.setHideAppContainer(true));
};

export const showAppContainer = () => (dispatch) => {
  dispatch(userReducer.setHideAppContainer(false));
};

export const logout = () => (dispatch) => {
  localStorage.removeItem('userRole');
  localStorage.removeItem('token');
  dispatch(userReducer.logout());
};
